export default function WhyChooseUs() {
  const reasons = [
    {
      icon: 'ri-medal-line',
      title: 'Experience & Expertise',
      description: 'Decades of industry knowledge and proven track record across multiple sectors'
    },
    {
      icon: 'ri-user-heart-line',
      title: 'Client-Centric Solutions',
      description: 'Tailored approaches that prioritize your unique needs and business objectives'
    },
    {
      icon: 'ri-settings-3-line',
      title: 'End-to-End Services',
      description: 'Comprehensive solutions from planning to execution and beyond'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Regulatory Integrity',
      description: 'Full compliance with all legal and regulatory requirements'
    },
    {
      icon: 'ri-leaf-line',
      title: 'Sustainable Practices',
      description: 'Environmentally responsible operations that create lasting value'
    }
  ];

  return (
    <section id="why-choose-us" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">Why Choose Us</h2>
          <div className="w-24 h-1 bg-[#C9A961] mx-auto mb-6"></div>
          <p className="text-gray-600 text-lg max-w-2xl mx-auto">
            Partnering with Vertak Group means choosing excellence, integrity, and innovation
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {reasons.map((reason, index) => (
            <div
              key={index}
              className="bg-gradient-to-br from-gray-50 to-white p-8 rounded-2xl border border-gray-100 hover:border-[#C9A961] transition-all duration-300 group hover:shadow-xl"
            >
              <div className="w-16 h-16 bg-gradient-to-br from-[#C9A961] to-[#B89851] rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
                <i className={`${reason.icon} text-3xl text-white`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">{reason.title}</h3>
              <p className="text-gray-600 text-sm leading-relaxed">{reason.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}